import { ReactNode } from 'react';
import styled from 'styled-components';
import { header4 } from '@ardoq/typography';

const ModalSubtitleStyle = styled.div`
  ${header4}
`;

interface ModalSubtitleProps {
  children?: ReactNode;
}

/** @deprecated please use text for all the text content instead */
const ModalSubtitle = ({ children }: ModalSubtitleProps) => (
  <ModalSubtitleStyle>{children}</ModalSubtitleStyle>
);

export { ModalSubtitle };
